import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["submit"]
  static values = { completeLabel: String }

  start() {
    this.submitTarget.value = "Uploading photos..."
    this.submitTarget.disabled = true
  }

  finish() {
    this.submitTarget.value = this.completeLabelValue
    this.submitTarget.disabled = false
  }
}
